module.exports = __webpack_public_path__ + "img/vignette-microtampons.e3e23747.jpg";